import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';

import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';

import { PdfReportService } from '../../../service/pdf-report/pdf-report.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { AccountBookService } from '../../../service/account-book/account-book.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';

@Component({
  selector: 'app-root',
  templateUrl: 'wa8004.component.html',
  styleUrls: ['wa8004.component.css']
})

export class Wa8004Component implements AfterViewInit {
  public componentTitle = 'WA8004:月次帳票ダウンロード';

  public owners: any;
  public bookyearmonths: any;

  public ownerId: number;
  public bookyearmonthTx: string;

  public reportCd: string;

  public reporttrnId: number;
  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  private reportOpened = false;
  private reportTry = 0;

  public url = '#';

  // todo should get from server
  reports = [
    { reportCd: 'RA8031', reportTx: '財務データ（勘定奉行向け）' },
  ];

  constructor(
    private router: Router,
    private pdfReportService: PdfReportService,
    private ownerService: OwnerService,
    private accountBookService: AccountBookService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ownerChange(event) {
    this.working = true;
    this.accountBookService
      .getBookYearMonth(this.ownerId)
      .then(outputJson => {
        this.working = false;
        console.log(JSON.stringify(outputJson));
        console.log(JSON.stringify(outputJson.bookyearmonths));
        this.bookyearmonths = outputJson.bookyearmonths;
      })
      .catch(error => {
        this.working = false;
        this.dialogsService
          .info('エラー', this.commonService.getErrorMessage(error))
      });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.ownerService
      .get()
      .then(outputJson => {
        console.log(JSON.stringify(outputJson));
        this.owners = outputJson.owners;
      })
      .catch(error => {
        this.dialogsService
          .info('エラー', this.commonService.getErrorMessage(error));
      });
  }

  onSubmit() {
    // Change the flag of working to true in order to disable the submit button
    this.working = true;
    if (this.ownerId === undefined) {
      this.dialogsService
        .info('エラー', '荷主を選択してください。');
      this.working = false;
      return;
    }
    if (this.bookyearmonthTx === undefined) {
      this.dialogsService
        .info('エラー', '計上年月を選択してください。');
      this.working = false;
      return;
    }
    if (this.reportCd === undefined) {
      this.dialogsService
        .info('エラー', '帳票を選択してください。');
      this.working = false;
      return;
    }
    // Reset the flag to indicate that the report has not been opened yet
    this.reportOpened = false;
    // Reset the limit counter
    this.reportTry = 0;
    // Submit the request to generate the report
    this.pdfReportService
      .post(
      this.ownerId,
      this.bookyearmonthTx,
      this.reportCd,
      0,
      'WA8004',
      )
      .then(outputJson => {
        this.reporttrnId = outputJson.reporttrnId;
        this.working = true;
        this.waitResult();
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.dialogsService
          .info('エラー', this.commonService.getErrorMessage(error))
      });
  }

  waitResult() {
    const obs = Observable.interval(1000)
      .subscribe(() => {
        // Verify that we have not tried more than 10 times
        if (this.reportTry <= 10) {
          // Add a new try to the counter
          this.reportTry++;
          // Call the PDF report service
          this.pdfReportService.get(this.reporttrnId)
            .then(outputJson => {
              // seems we can get the report path correctly
              // If the createdFl is 0 the report has not finished so we retry again.
              // If the createdFl is 1 we get the report name and open a new window to show the PDF file.
              if (outputJson.reports[0].createdFl === 1) {
                // Cancel the Observable when success
                obs.unsubscribe();
                // Change the working flag to false in order to enable the submit button
                this.working = false;
                const url = environment.bucketUrl + '/report/' + outputJson.reports[0].reportpathTx;
                // We open a new tab to display the PDF.
                // If preferred we could get the PDF data and send the blob to the new tab instead.
                this.openReport(url);
              }
              if (outputJson.reports[0].createdFl === -1) {
                // Cancel the Observable when success
                obs.unsubscribe();
                this.working = false;
                this.dialogsService
                  .info('エラー', '対象データがないため帳票が作成できませんでした。');
              }
            })
            .catch(error => {
              // Cancel the Observable in case of error
              obs.unsubscribe();
              // Change the working flag to false in order to enable the submit button
              this.working = false;
              console.log(this.commonService.getErrorMessage(error));
              this.dialogsService
                .info('エラー', this.commonService.getErrorMessage(error));
            });
        } else {
          // Cancel the Observable if the number of tries maxed out
          obs.unsubscribe();
          // Change the working flag to false in order to enable the submit button
          this.working = false;
          // TODO: Change the message in Japanese
          this.dialogsService
            .info('エラー', '帳票を取得できませんでした（タイムアウト）。再発する場合は管理者へ連絡してください。');
        }
      })
  }

  // Download the newly generated report.
  openReport(url) {
    const link = document.createElement('a');
    link.href = url;
    link.download = '財務データ（勘定奉行向け）';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa8Billing/wa8004/wa8004.component.ts